import React, { useCallback } from 'react'

import IntegrationAppAPI from 'api/integrationApp'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import Toggle from 'components/forms/Toggle'

/**
 * Scope Header
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 * @param {'serviceApi'|'activityApi'} props.type
 * @param {string} props.title
 * @param {string} props.description
 *
 * @returns {React.Component}
 */
const ScopeHeader = (props) => {
  const { app, setApp, type, title, description } = props

  const updateAPP = useCallback(
    (type, value) => {
      setApp(state => {
        if (!state[type]) state[type] = {}
        state[type].isActive = value

        return { ...state }
      })
    }, [setApp]
  )

  const onActiveAPI = useCallback(
    async (type, value) => {
      try {
        updateAPP(type, value)

        await IntegrationAppAPI.updateById({
          identifier: app._id,
          [type]: {
            isActive: value
          }
        })

        SaveToastNotification.ok()
      } catch (error) {
        updateAPP(type, !value)

        SaveToastNotification.error()
      }
    }, [updateAPP]
  )

  return (
    <>
      <div className='integrations-app-edit__scope-title-container'>
        <div className='integrations-app-edit__scope-title'>
          {title}
        </div>

        <div>
          <Toggle
            value={!!app[type]?.isActive}
            onClick={(value) => onActiveAPI(type, value)}
          />
        </div>
      </div>

      <div className='integrations-app-edit__info'>
        {description}
      </div>
    </>
  )
}

export default ScopeHeader
